import { render, staticRenderFns } from "./realAdjustment.vue?vue&type=template&id=09dfc302"
import script from "./realAdjustment.vue?vue&type=script&lang=js"
export * from "./realAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports